import { Link } from "react-router-dom";
import { categoryCards } from "@/mocks/hero";

export default function CategoryCards() {
  const items = [
    { key: "movie" as const, data: categoryCards.movie, to: "/category/movie" },
    { key: "tv" as const, data: categoryCards.tv, to: "/category/tv" },
  ];

  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            分类速览
          </h2>
          <p className="mt-1 text-sm text-foreground-500">按类型快速进入，发现你的下一部心头好</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {items.map(({ key, data, to }) => (
          <Link
            key={key}
            to={to}
            className="group relative block h-[200px] md:h-[260px] rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={data.image}
              alt={`${data.title}分类封面`}
              title={`天天影院 - ${data.title}分类`}
              className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-primary-950/10" />
            <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                {data.title}
              </h3>
              <p className="text-background-200 text-sm mb-3 line-clamp-2 max-w-md">{data.desc}</p>
              <div className="flex items-center justify-between">
                <span className="text-accent-400 text-sm font-medium">{data.count} 内容</span>
                <span className="inline-flex items-center gap-1 text-background-50 text-sm group-hover:text-accent-400 transition-colors">
                  进入分类
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}